import auth from 'Services/auth';

const usePermissions = () => auth.getPermissions();

export default usePermissions;
